import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
import { cardActionsLayout, cardOrientation } from './interfaces/Enums';
export var CardActions = function CardActions(props) {
  return React.createElement("div", {
    style: props.style,
    className: classNames('k-card-actions', props.className, "k-card-actions-" + props.layout, props.orientation !== cardOrientation.VERTICAL ? 'k-card-actions-horizontal' : 'k-card-actions-vertical')
  }, props.children);
};
CardActions.propTypes = {
  layout: PropTypes.oneOf(['stretched', 'start', 'center', 'end']),
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
CardActions.defaultProps = {
  layout: cardActionsLayout.START,
  orientation: cardOrientation.HORIZONTAL
};